import { useEffect, useMemo } from "react";

type MaybeDisposable = {
  dispose?: () => void;
};

export const useMemoizedStore = <T, P extends unknown[]>(
  Store: new (...args: P) => T,
  params: P,
  disposeCallback?: () => void
): T => {
  const store = useMemo(() => new Store(...params), [Store, ...params]);

  useEffect(() => {
    return () => {
      (store as MaybeDisposable).dispose?.();
      disposeCallback?.();
    };
  }, [store, disposeCallback]);

  return store;
};
